import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { Form } from "react-bootstrap";
import { FilterWidgetProps } from "../widgets";
import { DateRangePicker } from "react-dates";
import moment from "moment";
// @ts-ignore
import { defineMessages, IntlShape } from "react-intl";
import { DebounceInput } from "react-debounce-input";
import Selector from "../../../components/selector";

const msgs = defineMessages({
  dateStart: {
    id: "reservations.dateStart",
    defaultMessage: "dateStart",
  },
  dateEnd: {
    id: "reservations.dateEnd",
    defaultMessage: "dateEnd",
  },
  yes: {
    id: "default.yes",
    defaultMessage: "yes",
  },
  no: {
    id: "default.no",
    defaultMessage: "no",
  },
});

const StyledFormControl = styled(Form.Control)`
  width: 240px;
`;

//FIXME: this should only apply once per app
const DatePickerStyle = createGlobalStyle`
  .DateRangePicker_picker {
    z-index: 500;
  }
  .CalendarMonth_caption {
    text-transform: capitalize;
  }
`;

const StyledSelector = styled(Selector)`
  .css-yk16xz-control {
    max-height: 33px;
    min-height: 0;
  }
  .css-1pahdxg-control {
    max-height: 33px;
    min-height: 0;
  }
  .css-g1d714-ValueContainer {
    max-height: 33px;
    min-height: 0;
  }
`;

const DateRangePickerWrapper = styled.div`
  .DateRangePicker {
    border-radius: 5px;
  }

  .DateRangePickerInput {
    border-radius: 5px;
    width: 240px;
  }

  .DateInput {
    border-radius: 5px;
  }

  .DateInput_input {
    font-size: 13px;
  }
`;

export function inputFilter({ value, onChange, placeholder }: FilterWidgetProps<any>) {
  return (
    <DebounceInput
      element={StyledFormControl}
      minLength={0}
      debounceTimeout={300}
      type="text"
      value={value || ""}
      placeholder={placeholder}
      onChange={(e: any) => onChange(e.target.value)}
    />
  );
}

export function dateFilter(name: string, intl: IntlShape) {
  return ({ value, onChange, placeholder, onFocusChange, focused }: FilterWidgetProps<any>) => {
    let focusedInputNamed: "startDate" | "endDate" | null = null;
    let focusedInputArr;
    if (typeof focused === "string") {
      focusedInputArr = focused.split(" ");
    }
    if (focusedInputArr && focusedInputArr[1] === name) {
      focusedInputNamed = focused?.split(" ")[0] as "startDate" | "endDate";
    }

    return (
      <DateRangePickerWrapper>
        <DatePickerStyle />
        <DateRangePicker
          isOutsideRange={() => false}
          displayFormat="DD/MM/YYYY"
          startDate={value?.startDate ? moment(value?.startDate).utc() : null}
          startDateId={`startDate${name}`}
          endDate={value?.endDate ? moment(value?.endDate).utc() : null}
          endDateId={`endDate${name}`}
          onDatesChange={(dates: {
            endDate: moment.Moment | null;
            startDate: moment.Moment | null;
          }) => {
            return onChange({
              startDate: dates.startDate
                ? dates.startDate.utc().startOf("day").toISOString()
                : null,
              endDate: dates.endDate ? dates.endDate.utc().endOf("day").toISOString() : null,
            });
          }}
          focusedInput={focusedInputNamed}
          onFocusChange={focusedInput => {
            onFocusChange && onFocusChange(`${focusedInput} ${name}`);
          }}
          startDatePlaceholderText={`${intl?.formatMessage(
            msgs?.dateStart
          )} ${placeholder?.toLowerCase()}`}
          endDatePlaceholderText={`${intl?.formatMessage(
            msgs?.dateEnd
          )} ${placeholder?.toLowerCase()}`}
          small
          showClearDates
          withPortal
          minimumNights={0}
        />
      </DateRangePickerWrapper>
    );
  };
}

export function selectFilter(
  intl: IntlShape,
  defaultMsg: {
    id: string;
    defaultMessage: string;
  }
) {
  return ({ value, onChange, width }: FilterWidgetProps<any>) => (
    <Form.Control
      style={{ width: !width ? "240px" : typeof width === "number" ? `${width}px` : width }}
      as="select"
      onChange={(e: any) => onChange(e.target.value)}
      value={value || "undefined"}>
      <option value="undefined">{intl?.formatMessage(defaultMsg)}</option>
      <option value="true">{intl?.formatMessage(msgs?.yes)}</option>
      <option value="false">{intl?.formatMessage(msgs?.no)}</option>
    </Form.Control>
  );
}

export function selectorFilter(
  placeholder: any,
  options: { value: string | string[]; label: string }[]
) {
  function setValue(value: string) {
    return Array.isArray(options) && options.find(option => option.value === value);
  }
  return ({ value, onChange, width }: FilterWidgetProps<any>) => {
    return (
      <div style={{ width: !width ? "240px" : typeof width === "number" ? `${width}px` : width }}>
        <StyledSelector
          isClearable
          options={options}
          value={setValue(value) || ""}
          onChange={(it: { value: string }) => {
            return onChange(it?.value);
          }}
          placeholder={placeholder}
          portal={true}
        />
      </div>
    );
  };
}
